/**
 * Return the email address for the campus with the given id.
 */
const getCampusEmail = (campusId: string) => {
	return `${campusId}@aopsacademy.org`;
};

export default getCampusEmail;
